import { render } from "./PortfolioCarousel.vue?vue&type=template&id=5a7d7251"
import script from "./PortfolioCarousel.vue?vue&type=script&lang=js"
export * from "./PortfolioCarousel.vue?vue&type=script&lang=js"

import "./PortfolioCarousel.vue?vue&type=style&index=0&id=5a7d7251&lang=css"
script.render = render

export default script